import { jsx as _jsx } from "react/jsx-runtime";
import { BaseColor } from '@prophecy/theme';
import { Tooltip } from '../../Tooltip';
import { StyledEntityIcon } from './styled';
import { Variant, Size } from './types';
export const EntityIcon = ({ variant = Variant.singleColor, icon, size = Size.m, color = BaseColor.grayBlue, tooltip, hideTooltip, className }) => (_jsx(Tooltip, { title: tooltip, disabled: !!hideTooltip, children: _jsx(StyledEntityIcon, { "$variant": variant, "$size": size, "$color": color, className: className, shrink: '0', children: icon }) }));
